import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-mu-rating',
  templateUrl: './mu-rating.component.html',
  styleUrls: ['./mu-rating.component.sass'],
})
export class MuRatingComponent implements OnInit {
  @Input() formData: UntypedFormGroup;
  @Input() field: string;
  @Input() stars = 5;
  @Input() cancel = false;
  @Input() disabled = false;
  @Input() readOnly = false;

  constructor() {
    /** */
  }

  ngOnInit(): void {
    /** */
  }
}
